import { auth } from '@sagano/agent/stores';
import ShareAuth from '@sagano/share/vendors/firebase';

export type { UserCredential } from '@linktivity/link-utils';

const agentAuth = new ShareAuth(auth);

export const storage = agentAuth.storage;
export default agentAuth;
